export default "__VITE_ASSET__BHjvjaum__"